module.exports = __webpack_public_path__ + "static/reczebracomforter-c20477f244628381445b96017b60b501.jpeg";